// material-ui
import logo from '../assets/images/icons/logo.png';

const Logo = () => <img src={logo} alt="logo" style={{ width: 100, height: 50 }} />;

export default Logo;
